module.exports = __webpack_public_path__ + "img/person_menu_trash_normal.552241df.svg";